module.exports = __webpack_public_path__ + "img/del-selected-file.c6320ab0.svg";